module.exports = __webpack_public_path__ + "static/media/ion_call-outline.3ffcf099.svg";